import React from "react";

const Item = props => <option {...props} />;

export default Item;
